import { IMenu } from "../interfaces/menu";
import {
  DashboardIcon,
  EmployeeCardIcon,
  InvoiceIcon,
  ProfileIcon,
} from "../components/Icon";
import { SettingsIcon } from "@chakra-ui/icons";

const menus: IMenu[] = [
  {
    label: "Dashboard",
    icon: <DashboardIcon boxSize="24px" />,
    link: "/",
  },
  {
    label: "Invoices",
    icon: <InvoiceIcon boxSize="24px" />,
    link: "/invoice",
  },
  {
    label: "Quotations",
    icon: <InvoiceIcon boxSize="24px" />,
    link: "/quotation",
  },
  {
    label: "Settings",
    icon: <SettingsIcon boxSize="24px" />,
    items: [
      {
        label: "Invoice",
        link: "/invoice-setting",
      },
      {
        label: "Quotation",
        link: "/quotation-setting",
      },
      {
        label: "Signatures",
        link: "/signature",
      },
      {
        label: "Signature Backgrounds",
        link: "/signature-background",
      },
      {
        label: "Payment Details",
        link: "/payment-detail",
      },
    ],
  },
  // {
  //   label: "User",
  //   icon: <EmployeeCardIcon boxSize="24px" />,
  //   link: "/user",
  // },
  {
    label: "Profile",
    icon: <ProfileIcon boxSize="24px" />,
    link: "/me",
  },
];

export default menus;
